module.exports = __webpack_public_path__ + "static/img/minicons5.7af91f21.png";